<template>
    <a v-if="product" :href="product.slug_suffix" class="grid-assortment__item assortment-item Tulips">
        <div class="assortment-item__image -ibg_contain">
            <picture>
                <source v-if="product.thumbnail && product.thumbnail.media_webp_small_url"
                    :srcset="product.thumbnail.media_webp_small_url" type="image/webp">
                <img loading="lazy" :src="product.thumbnail.media_small_url" :alt="product.meta.title">
            </picture>
            <picture>
                <source v-if="product.thumbnail_2 && product.thumbnail_2.media_webp_small_url"
                    :srcset="product.thumbnail_2.media_webp_small_url" type="image/webp">
                <img loading="lazy" v-if="product.thumbnail_2" :src="product.thumbnail_2.media_small_url" :alt="product.meta.title"
                    class="image-hover">
            </picture>
        </div>
        <div class="assortment-item__content">
            <div v-if="product.meta" class="assortment-item__title">{{ product.meta.title }}</div>
            <span class="assortment-item__price">
                <span v-if="product.type == 'variety' && product.default_child" class="card-price">
                        {{ trans('home.from') }} {{ (Math.round(Number(product.price_range_veriety.min))).toLocaleString('uk') }} ₴
                </span>
                <span v-else-if="product.type == 'variety' && !product.default_child" class="card-price">
                    {{ (Math.round(Number(product.price_range_veriety.min))).toLocaleString('uk') }} - {{ (Math.round(Number(product.price_range_veriety.max))).toLocaleString('uk') }} ₴
                </span>
                <template v-else>
                    <span v-if="product.sale_counted > 0">
                        <span class="card-price">
                            - {{ product.sale_counted }} %
                        </span>
                        <span class="card-price-prev">
                            {{ (Math.round(product.price)).toLocaleString('uk') }} ₴
                        </span>
                    </span>
                    <span class="card-price">
                        {{ product.meta.price_prefix }} {{ (Math.round(product.price_finaly)).toLocaleString('uk') }} ₴ {{ product.meta.price_suffix }}
                    </span>
                </template>
            </span>
        </div>
    </a>
</template>

<script>
export default {
    props: {
        product: {
            requeired: false,
            default: null
        }
    },
    data() {
        return {
            
        }
    },
    beforeMount() {
        
    },
    mounted() {
        
    },
    methods: {
        
    }
}
</script>